import _ from "lodash";

export const getTableOptionsActionName = (options, key) => {
  return _.get(options, `actionsNames.${key}`);
}